import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-custom-lib',
  template: `
                        <button mat-raised-button class="save-button" color="primary">Login</button>
  
  `,
  styles: []
})
export class CustomLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
